var map = {
	"./background.svg": "g+Js",
	"./backstage.svg": "hs63",
	"./basedata.svg": "BPZu",
	"./collapse.svg": "2qk3",
	"./db.svg": "TvJ2",
	"./finance.svg": "Mjhk",
	"./home.svg": "GU1v",
	"./language.svg": "uSl1",
	"./menu.svg": "91sd",
	"./order.svg": "yFCU",
	"./search.svg": "EqOI",
	"./tax.svg": "JIf1",
	"./tool.svg": "3T7B",
	"./u2752.svg": "LrV+",
	"./u316.svg": "2fPW",
	"./user.svg": "EOg8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VZYf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg nonrecursive \.svg$
// module id = VZYf
// module chunks = 19